<template>
  <div>
    <el-dialog
      title="院校明细信息"
      :visible.sync="show"
      width="60%" @open="open" @close="closeForm()" top="2vh">
      <!-- storage 将窗口拖动的状态保存到本地 remember 再次打开窗口时还原窗口状态-->
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span
              >{{ form.collegeName }}
              <span v-if="form.detail">{{ form.detail.collegeProperty }}</span>
            </span>
            <span style="float: right; padding: 3px 0"
              >招生计划：{{ form.nature }}-{{ form.planned_number }}人</span
            >
          </div>
          <div style="width: 100%; display: flex; flex-wrap: wrap">
            <div style="width: 20%; display: flex; align-items: center">
              录取省份：{{ form.province }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              预测年份：{{ form.current_year }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              录取批次：{{ form.batch }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              组别：{{ form.group_d }}
            </div>
            <div style="width: 20%; display: flex; align-items: center">
              预测最低分：<span style="color: #177dff !important">{{
                form.score || "--"
              }}</span>
            </div>
            <!-- <div style="width: 16.6%;display: flex;align-items: center;">
					       预测平均分：<span style="color: #35cd3a !important;">551</span>
					   </div> -->
          </div>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px" v-if="form.detail">
          <table class="table table-bordered">
            <tbody>
              <tr>
                <th class="text-center" style="width: 12%">主管部门</th>
                <td style="width: 38%">{{ form.detail.collegeAdmin }}</td>
                <th class="text-center" style="width: 12%">地理位置</th>
                <td style="width: 38%">{{form.detail.collegeProvince}}-{{ form.detail.collegeCity }}-{{form.detail.collegeArea}}</td>
              </tr>
              <tr>
                <th class="text-center" style="width: 12%">院校简介</th>
                <td style="width: 38%">{{ form.detail.college_info }}</td>
                <th class="text-center" style="width: 12%">院校性质</th>
                <td style="width: 38%">{{ form.detail.collegeLevel }}</td>
              </tr>
              <tr>
                <th class="text-center" style="width: 12%">综合排名</th>
                <td style="width: 38%">
                  {{ form.detail.ruan_pai || "--" }}
                </td>
                <th class="text-center" style="width: 12%">院校类别</th>
                <td style="width: 38%">{{ form.detail.collegeType }}</td>
              </tr>
              <!-- <tr>
                <th class="text-center" style="width: 12%">顶尖师资</th>
                <td style="width: 38%">{{ form.detail.teachers }}</td>
                <th class="text-center" style="width: 12%">重点学科</th>
                <td style="width: 38%">{{ form.detail.advantage }}</td>
              </tr> -->
              <tr>
                <th class="text-center" style="width: 12%">招生页面</th>
                <td style="width: 38%">
                  <a :href="form.detail.zhaosheng" target="_blank">{{form.detail.zhaosheng || "--"}}</a>
                </td>
                <th class="text-center" style="width: 12%">占地面积</th>
                <td style="width: 38%">{{ form.detail.zhandi || "--" }}亩</td>
              </tr>
              <tr>
                <th class="text-center" style="width: 12%">学校地址</th>
                <td style="width: 38%">{{ form.detail.address_detail }}</td>
                <th class="text-center" style="width: 12%">联系电话</th>
                <td style="width: 38%">{{ form.detail.phone }}</td>
              </tr>
            </tbody>
          </table>
        </el-card>
        <el-card class="box-card" style="margin-top: 20px">
          <el-table :data="form.scorrl" border style="width: 100%">
            <el-table-column label="年份" width="100">
				<template slot-scope="scope">
					<span>{{scope.row.year || "--"}}</span>
				</template>
            </el-table-column>
			<el-table-column show-overflow-tooltip  label="招生计划名称">
				<template slot-scope="scope">
					<span>{{scope.row.collegeName || "--"}}</span>
				</template>
            </el-table-column>
			<el-table-column width="100" label="计划">
				<template slot-scope="scope">
					<span>{{scope.row.planned_number || "--"}}</span>
				</template>
            </el-table-column>
			<el-table-column width="100" label="批次">
				<template slot-scope="scope">
					<span>{{scope.row.batch || "--"}}</span>
				</template>
            </el-table-column>
			<el-table-column width="120" label="组别">
				<template slot-scope="scope">
					<span>{{scope.row.group_d || "--"}}</span>
				</template>
            </el-table-column>
			<el-table-column width="100" label="最低分">
				<template slot-scope="scope">
					<span style="color: #177dff !important;">{{scope.row.score || "--"}}</span>
				</template>
            </el-table-column>
			<el-table-column width="120" label="最低分排名">
				<template slot-scope="scope">
					<span style="color: #177dff !important;">{{scope.row.seat || "--"}}</span>
				</template>
            </el-table-column>
          </el-table>
        </el-card>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" :size="size" @click="closeForm"
            >确 定</el-button
          >
        </span>
    </el-dialog>
  </div>
</template>
<script>
import { RecruitData_detail } from "@/api/gw/major.js";
export default {
  name: "RecruitDatadetail",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: "mini",
    },
    info: {
      type: Object,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    open() {
      RecruitData_detail(this.info).then((res) => {
        this.form = res.data;
      });
    },
    closeForm() {
      this.$parent.dialog.detailDialogStatus = false
    },
  },
};
</script>
<style  lang="scss">
.descLabel {
  width: 90px;
}
.table {
  color: #555 !important;
  width: 100%;
}
.table-bordered {
  border: 1px solid #dee2e6;
}
.table td,
.table th {
  font-size: 13px;
  border-top-width: 0px;
  border-bottom: 1px solid;
  border-color: #ebedf2 !important;
  padding: 0.75rem !important;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/views/RecruitData/components/detail.vue